import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { MDText } from 'i18n-react';

const MeetingItemLinkedEntitiesCellItem = ({ entity }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const cellValue = entity.orderIndex
    ? `${T.translate('MEETING_ITEM')} ${entity.orderIndex}`
    : entity.orderIndex;
  return <span>{cellValue}</span>;
};

MeetingItemLinkedEntitiesCellItem.propTypes = {
  /**
   * The Meeting Item entity we need to render.
   */
  entity: PropTypes.object.isRequired
};

export default MeetingItemLinkedEntitiesCellItem;
